import React from 'react';
import TimelineIcon from '@mui/icons-material/Timeline';

import { useAppMonitor } from '../../../monitor';
import { setDisplayAnalogModel } from '../../../store/actions/visualOptionActions';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function AnalogModelVisibilityButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const inLayoutMode = useAppSelector(isLayoutViewActive);
  const analogModelDisplayed = useAppSelector((state) => state.visualOptions.showAnalogModel);

  if (inLayoutMode) return null;

  return (
    <ToolbarIconButton
      icon={<TimelineIcon />}
      title={`${analogModelDisplayed ? 'Hide' : 'Show'} Analog Model`}
      toggleValue={analogModelDisplayed}
      onClick={() => {
        dispatch(setDisplayAnalogModel(!analogModelDisplayed));
        monitor.recordInteraction('Analog model visibility manually toggled');
      }}
    />
  );
}
